import { reorderablePreview } from '../../shared/components/reorderable.jsx'
import EditableSectionQuestion from './editable_section_question.jsx'

export default reorderablePreview(EditableSectionQuestion, 'DraggableSectionQuestion')
